var map = {
	"./Subtract.png": 1379,
	"./border.png": 1380,
	"./cancel.png": 1381,
	"./coupon-bg-not-login.png": 1382,
	"./coupon-gift-left-double.png": 1383,
	"./coupon-gift-left-one.png": 1384,
	"./coupon-gift-top.png": 1385,
	"./facebook-icon.png": 1386,
	"./google-icon.png": 1387,
	"./guide-header.png": 1130,
	"./login/facebook.png": 1388,
	"./login/google.png": 1119,
	"./login/vk.png": 1120,
	"./loginbtn-facebook.png": 1389,
	"./loginbtn-google.png": 1121,
	"./notice-background-header.png": 1390,
	"./submit.png": 1391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2012;